export default __webpack_public_path__ + "static/Chainlink-Build-Logo-ab50ca452d1f7ef32fea58da07633d1e.png";